import React from "react";

// Lightweight, GPU-free stand-in for the WebGL globe — used on phones / reduced-motion
// so the marketing page stays smooth. Pure SVG, a few gently pulsing member dots.
export default function StaticGlobe({ height = 360 }) {
  const dots = [[70, 62], [128, 78], [96, 118], [122, 132], [62, 104], [112, 54], [142, 108], [80, 140]];
  return (
    <div className="relative mx-auto flex items-center justify-center" style={{ height }} data-testid="static-globe">
      <div className="pointer-events-none absolute h-[68%] w-[68%] rounded-full bg-brand/12 blur-[70px]" />
      <svg viewBox="0 0 200 200" className="relative h-[86%] w-auto" aria-hidden="true">
        <defs>
          <radialGradient id="sg-fill" cx="38%" cy="30%" r="78%">
            <stop offset="0%" stopColor="#14345f" />
            <stop offset="60%" stopColor="#0b1c36" />
            <stop offset="100%" stopColor="#060d1a" />
          </radialGradient>
        </defs>
        <circle cx="100" cy="100" r="82" fill="url(#sg-fill)" stroke="#6AA6FF44" strokeWidth="1" />
        {[0.35, 0.62, 0.86].map((k, i) => (
          <ellipse key={i} cx="100" cy="100" rx={82 * k} ry="82" fill="none" stroke="#6AA6FF22" strokeWidth="0.7" />
        ))}
        {[-42, 0, 42].map((y, i) => (
          <line key={i} x1="22" y1={100 + y} x2="178" y2={100 + y} stroke="#6AA6FF1A" strokeWidth="0.7" />
        ))}
        {dots.map(([x, y], i) => (
          <circle key={i} cx={x} cy={y} r="2.4" fill="#7DB2FF">
            <animate attributeName="opacity" values="0.35;1;0.35" dur={`${2.4 + i * 0.35}s`} repeatCount="indefinite" />
          </circle>
        ))}
      </svg>
    </div>
  );
}
